export default __webpack_public_path__ + "static/media/carouselLeftNav.8cd73ba3.svg";